<div
  class="modal-backdrop"
  *ngIf="data.open"
  [ngClass]="[
    data.customClass || '',
    isApplicantMobileview ? 'modal-backdrop-mobile' : ''
  ]"
  (click)="handleBackdropClick()"
  tabindex="0"
  (keydown.escape)="handleBackdropClick()"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="data.modalDescp ? 'modal-title' : null"
  [attr.aria-describedby]="data.modalSubDescp ? 'modal-subtitle' : null"
>
  <div
    class="modal-content"
    [ngClass]="{ 'modal-content-mobile': isApplicantMobileview }"
    [ngStyle]="modalStyles"
    (click)="$event.stopPropagation()"
    [@slideInOut]="{ value: '', params: { inTime: data.inTime, outTime: data.outTime } }"
  >
    <div class="modal-scroll">
      <button
        class="close-button"
        (click)="handleCloseClick()"
        aria-label="Close dialog"
      >
        ✕
      </button>
      <!-- Title -->
      <div class="modal-title" *ngIf="data.modalDescp">
        <wm-common-text [data]="{text: data.modalDescp}"></wm-common-text>
        <wm-common-text [data]="{text: data.modalSubDescp}"></wm-common-text>
      </div>

      <!-- Projected content (forms, extra text, etc.) -->
      <div class="modal-body">
        <ng-content></ng-content>
      </div>

      <!-- YES / NO Buttons -->
      <div *ngIf="data.yesNoBtn" class="button-group">
          <wm-common-button [data]="getNoButtonData()"></wm-common-button>
          <wm-common-button [data]="getYesButtonData()"></wm-common-button>
      </div>

      <!-- CLOSE Button -->
      <div *ngIf="data.closeBtn" class="button-group">
        <wm-common-button [data]="getCloseButtonData()"></wm-common-button>
      </div>

      <!-- OK Button -->
      <div *ngIf="data.okBtn" class="button-group">
        <wm-common-button [data]="getOkButtonData()"></wm-common-button>
      </div>
    </div>
  </div>
</div>
